import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyxLighter} from '/theme/color/on.color';
import {black, white} from '/theme/color/on.color';
import {blueLagoon, pine, pineDark} from '/theme/color/secondary.color';

import {DARK} from './PinInput.constant';

const commonStyles = {
  container: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  textInputContainer: {
    marginTop: indent * 1.6,
    alignItems: 'stretch',
    flexDirection: 'row',
    justifyContent: 'center',
    position: 'relative',
  },
  innerContainer: {
    position: 'absolute',
    margin: 0,
    height: '100%',
    flexDirection: 'row',
    alignItems: 'center',
  },
  input: {
    opacity: 0,
    flex: 1,
    textAlign: 'center',
    height: indent * 1.6,
  },
};

// @ts-expect-error TS(2345): Argument of type '{ container: { flexDirection: st... Remove this comment to see the full error message
const darkThemedStyles = StyleSheet.create({
  cell: {
    width: indent * 1.6,
    height: indent * 1.6,
    borderRadius: 50,
    marginHorizontal: indent * 0.8,
    borderWidth: 2,
    borderColor: onyxLighter,
  },
  cellFocused: {
    backgroundColor: pine,
    borderWidth: 4,
    borderColor: pineDark,
  },
  cellFilled: {
    backgroundColor: pine,
    borderWidth: 4,
    borderColor: pineDark,
  },
  wrongCell: {
    borderWidth: 4,
    backgroundColor: 'transparent',
    borderColor: onyxLighter,
  },
  text: {
    color: black,
  },
  linearGradient: {
    marginTop: -4,
    marginLeft: -4,
    width: indent * 1.6,
    height: indent * 1.6,
    borderRadius: 50,
  },
  ...commonStyles,
});

// @ts-expect-error TS(2345): Argument of type '{ container: { flexDirection: st... Remove this comment to see the full error message
const lightThemedStyles = StyleSheet.create({
  cell: {
    width: indent * 1.6,
    height: indent * 1.6,
    borderRadius: 50,
    marginHorizontal: indent * 0.8,
    borderWidth: 3,
    borderColor: white,
  },
  cellFocused: {},
  cellFilled: {
    backgroundColor: white,
    borderWidth: 3,
    borderColor: white,
  },
  wrongCell: {},
  text: {
    color: white,
  },
  linearGradient: {},
  ...commonStyles,
});

export const stylesThemed = (theme: any) =>
  theme === DARK ? darkThemedStyles : lightThemedStyles;

export const gradient = [blueLagoon + '33', blueLagoon];
